import { Component } from "@angular/core"


@Component({
  selector: 'benefits-carousel',
  template: `
    <carousel interval="5000">
      <slide>
        <p class="font-weight-100 text-gray">100% original content from highly-vetted U.S.-based writers</p>
      </slide>
      <slide>
          <p class="font-weight-100 text-gray">Receive multiple submissions from different writers, keep only what you like</p>
      </slide>
      <slide>
        <p class="font-weight-100 text-gray">Unlimited rounds of edits</p>
      </slide>
      <slide>
        <p class="font-weight-100 text-gray">Most customers receive content to review in 48 hours or less</p>
      </slide>
      <slide>
        <p class="font-weight-100 text-gray">Change your monthly subscription any time – no contracts or fees</p>
      </slide>
  </carousel>
  `
})
export class BenefitsCarousel {
}
